import React, { forwardRef, useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../form/Button";
import { apiRequest } from "src/async/apiUtils";
import { useParams } from "react-router-dom";
import Modal from "./Modal";

const NotificationBanner = forwardRef(({ data, site, workspaceDetails, from }, ref) => {
  const [show, setShow] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const { workspace_id } = useParams();
  const [preview, setPreview] = useState("");

  const disMissNotification = async () => {
    setShow(false);
    if (from === "header") {
      try {
        await apiRequest("POST", "/portal/workspaces/:workspace_id/notifications/:notification_id/dismiss", { params: { workspace_id, notification_id: data?._id } });
      } catch (error) {}
    }
  };

  const handleShowMore = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    setShow(true);
    setPreview(data?.content?.slice(0, 200));
  }, [data?.content, data?._id]);

  return (
    <>
      {show && (
        <div
          ref={ref}
          style={{ backgroundColor: data?.background_color, color: data?.text_color }}
          className="animate-fade-in relative px-4 py-3">
          <div className="flex items-center gap-3 px-3">
            <div className="flex-shrink flex-grow space-y-2">
              <div className="whitespace-pre-wrap break-all text-base font-medium !leading-tight">
                {preview}
                {data?.content?.length > 200 && "... "}
                {data?.content?.length > 200 && (
                  <button
                    type="button"
                    onClick={handleShowMore}
                    className="ml-2 px-1.5 text-base font-semibold underline"
                    style={{ color: data?.text_color }}>
                    Show more
                  </button>
                )}
              </div>
            </div>
            <div className="ml-auto flex-shrink-0">
              <Button
                buttonHasLink={false}
                buttonFunction={disMissNotification}
                buttonClasses={"!p-0 !h-10 !w-10 !bg-transparent !text-slate-500"}
                buttonLabel={
                  <XMarkIcon
                    className="h-6 w-6"
                    style={{ color: data?.text_color }}
                  />
                }
                buttonLabelClasses={"transition-none"}
              />
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={showPopup}
        defaultStyles={{ overFlowYVisible: false }}
        defaultOptions={{ onCancelButtonVisible: false, onSuccessButtonVisible: false, wordWrap: true, customStyles: { backgroundColor: data?.background_color, color: data?.text_color } }}
        onCancel={closePopup}>
        {data?.content}
      </Modal>
    </>
  );
});

export default NotificationBanner;
